module.exports = "https://static.wmbcdn.com/uniweb/images/7860ab2693f49f2417ebfea41b7ea4de.svg";